/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CalculationType } from './CalculationType';
import {
    CalculationTypeFromJSON,
    CalculationTypeFromJSONTyped,
    CalculationTypeToJSON,
    CalculationTypeToJSONTyped,
} from './CalculationType';

/**
 * 
 * @export
 * @interface GetCalculationCycleRequest
 */
export interface GetCalculationCycleRequest {
    /**
     * 
     * @type {CalculationType}
     * @memberof GetCalculationCycleRequest
     */
    calculationType: CalculationType;
    /**
     * 
     * @type {any}
     * @memberof GetCalculationCycleRequest
     */
    fromDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetCalculationCycleRequest
     */
    toDate: any | null;
}



/**
 * Check if a given object implements the GetCalculationCycleRequest interface.
 */
export function instanceOfGetCalculationCycleRequest(value: object): value is GetCalculationCycleRequest {
    if (!('calculationType' in value) || value['calculationType'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    return true;
}

export function GetCalculationCycleRequestFromJSON(json: any): GetCalculationCycleRequest {
    return GetCalculationCycleRequestFromJSONTyped(json, false);
}

export function GetCalculationCycleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCalculationCycleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'calculationType': CalculationTypeFromJSON(json['calculationType']),
        'fromDate': json['fromDate'],
        'toDate': json['toDate'],
    };
}

export function GetCalculationCycleRequestToJSON(json: any): GetCalculationCycleRequest {
    return GetCalculationCycleRequestToJSONTyped(json, false);
}

export function GetCalculationCycleRequestToJSONTyped(value?: GetCalculationCycleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calculationType': CalculationTypeToJSON(value['calculationType']),
        'fromDate': value['fromDate'],
        'toDate': value['toDate'],
    };
}

